import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.module.generic');
import { OnInit, OnChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-module-generic',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportModuleGenericComponent implements OnInit, OnChanges {
    @Input() program_id: string = '';
    @Input() module_id: string = '';
    @Input() module_type: string = ''; // ir|networking|visit|submission|evaluation|etc

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public module: any = null;
    public sessions: any[] = [];
    public submissions: any[] = [];
    public feedbacks: any[] = [];
    public applications: any[] = [];
    public selectedSession: any = null;
    public attendance: any[] = [];

    public tab: string = 'settings';

    public showSessionEditor: boolean = false;
    public editingSession: any = null;

    public showFeedback: boolean = false;
    public newFeedback: any = { content: '', score: 0, feedback_type: 'general', application_id: '', is_visible_to_company: true };

    public reviewing: any = null;
    public reviewForm: any = { comment: '', status: 'reviewed', score: '' };

    public configForm: any = {};
    public configSaving: boolean = false;
    public mentorUsers: any[] = [];
    public assignments: any[] = [];
    public assignmentSaving: any = {};
    public inviteLoading: any = {};
    public mentorInviteLoading: any = {};
    public selectedAssignmentIds: any = {};
    public bulkInviteLoading: boolean = false;

    // 참석확인 발송 상태
    public attendanceRequests: any[] = [];
    public attReqLoading: boolean = false;
    public attReqStatusMap: any = {
        pending: { label: '응답대기', cls: 'bg-zinc-100 text-zinc-600' },
        attending: { label: '참석', cls: 'bg-emerald-100 text-emerald-800' },
        not_attending: { label: '불참', cls: 'bg-red-100 text-red-800' },
    };

    // 선발 모듈 전용: 신청기업 자료/첨부파일 직접 조회
    public applicantStatusFilter: string = '';   // '' = 전체 신청기업
    public expandedAppId: string = '';

    public appStatusMap: any = {
        submitted:  { label: '제출완료', cls: 'bg-blue-50 text-blue-700' },
        screening:  { label: '서류검토', cls: 'bg-amber-50 text-amber-700' },
        doc_passed: { label: '서류합격', cls: 'bg-emerald-50 text-emerald-700' },
        doc_failed: { label: '서류탈락', cls: 'bg-red-50 text-red-700' },
        pt_passed:  { label: 'PT합격',  cls: 'bg-emerald-50 text-emerald-700' },
        pt_failed:  { label: 'PT탈락',  cls: 'bg-red-50 text-red-700' },
        selected:   { label: '선정',     cls: 'bg-emerald-100 text-emerald-800 font-semibold' },
        rejected:   { label: '미선',     cls: 'bg-zinc-100 text-zinc-600' },
        withdrawn:  { label: '철회',     cls: 'bg-zinc-100 text-zinc-500' },
    };

    public typeMeta: any = {
        recruitment: { icon: '📢', label: '모집공고',   sessionLabel: '공고 회차',  useSubmission: true,  useFeedback: false, useAttendance: false },
        selection:   { icon: '✅', label: '선발',       sessionLabel: '선발 절차',  useSubmission: false, useFeedback: true,  useAttendance: false, useApplicants: true },
        kickoff:     { icon: '🚩', label: '킥오프',     sessionLabel: '킥오프 일정', useSubmission: false, useFeedback: true,  useAttendance: true },
        diagnosis:   { icon: '📊', label: '진단',       sessionLabel: '진단 회차',  useSubmission: true,  useFeedback: true,  useAttendance: true },
        education:   { icon: '📚', label: '교육',       sessionLabel: '교육 회차',  useSubmission: true,  useFeedback: true,  useAttendance: true },
        mentoring:   { icon: '👥', label: '멘토링',     sessionLabel: '멘토링 회차', useSubmission: true,  useFeedback: true,  useAttendance: true },
        workshop:    { icon: '🛠️', label: '워크숍',     sessionLabel: '워크숍 회차', useSubmission: true,  useFeedback: true,  useAttendance: true },
        networking:  { icon: '🤝', label: '네트워킹',   sessionLabel: '교류회',     useSubmission: false, useFeedback: true,  useAttendance: true },
        site_visit:  { icon: '🚗', label: '현장방문',   sessionLabel: '방문 일정',  useSubmission: false, useFeedback: true,  useAttendance: true },
        ir_pitching: { icon: '🎤', label: 'IR 피칭',    sessionLabel: 'IR 발표',    useSubmission: true,  useFeedback: true,  useAttendance: true },
        demoday:     { icon: '💼', label: '데모데이',   sessionLabel: '데모데이/IR', useSubmission: true,  useFeedback: true,  useAttendance: true },
        funding_match:{ icon: '💰', label: '투자매칭',  sessionLabel: '매칭 일정',  useSubmission: true,  useFeedback: true,  useAttendance: true },
        expense_mgmt:{ icon: '🧾', label: '예산집행',   sessionLabel: '정산 일정',  useSubmission: true,  useFeedback: true,  useAttendance: false },
        survey:      { icon: '📝', label: '만족도조사', sessionLabel: '조사 일정',  useSubmission: true,  useFeedback: true,  useAttendance: false },
        company_mgmt:{ icon: '🏢', label: '기업관리',   sessionLabel: '관리 일정',  useSubmission: false, useFeedback: true,  useAttendance: false },
        follow_up:   { icon: '🔁', label: '사후관리',   sessionLabel: '관리 일정',  useSubmission: true,  useFeedback: true,  useAttendance: false },
        reporting:   { icon: '📄', label: '보고',       sessionLabel: '보고 회차',  useSubmission: true,  useFeedback: true,  useAttendance: false },
        // legacy
        ir:          { icon: '💼', label: 'IR/투자유치', sessionLabel: '데모데이/IR', useSubmission: true,  useFeedback: true,  useAttendance: true },
        visit:       { icon: '🏢', label: '현장방문',   sessionLabel: '방문 일정',  useSubmission: false, useFeedback: true,  useAttendance: true },
        submission:  { icon: '📤', label: '과제 제출',  sessionLabel: '제출 마감',  useSubmission: true,  useFeedback: true,  useAttendance: false },
        evaluation:  { icon: '⭐', label: '추가 평가',  sessionLabel: '평가 일정',  useSubmission: true,  useFeedback: true,  useAttendance: true },
        etc:         { icon: '📋', label: '기타',       sessionLabel: '일정',       useSubmission: true,  useFeedback: true,  useAttendance: true },
    };

    public fieldSchemas: any = {
        recruitment: [
            { key: 'apply_url', label: '신청 URL', type: 'text', placeholder: 'https://' },
            { key: 'recruit_count', label: '모집 인원', type: 'number' },
            { key: 'recruit_method', label: '모집 방식', type: 'select', options: ['상시', '공고'] },
            { key: 'eligibility', label: '신청 자격', type: 'textarea' },
            { key: 'application_form', label: '신청서 양식 안내', type: 'textarea' },
        ],
        selection: [
            { key: 'select_count', label: '선정 기업 수', type: 'number' },
            { key: 'weight_paper', label: '서류 평가 비중(%)', type: 'number' },
            { key: 'weight_present', label: '발표 평가 비중(%)', type: 'number' },
            { key: 'publish_results', label: '결과 공개', type: 'checkbox' },
        ],
        kickoff: [
            { key: 'venue', label: '장소', type: 'text' },
            { key: 'attendance_required', label: '참석 필수', type: 'checkbox' },
            { key: 'agenda', label: '주요 안건', type: 'textarea' },
        ],
        diagnosis: [
            { key: 'cycle', label: '진단 주기', type: 'select', options: ['1회', '월간', '분기', '반기'] },
            { key: 'mandatory', label: '필수 여부', type: 'checkbox' },
            { key: 'use_global_template', label: '전역 템플릿 사용', type: 'checkbox' },
        ],
        education: [
            { key: 'instructor', label: '강사', type: 'text' },
            { key: 'session_count', label: '회차 수', type: 'number' },
            { key: 'hours_per_session', label: '회차당 시간(h)', type: 'number' },
            { key: 'attendance_required', label: '출석 필수', type: 'checkbox' },
            { key: 'curriculum', label: '교육 과정', type: 'textarea' },
        ],
        workshop: [
            { key: 'topic', label: '주제', type: 'text' },
            { key: 'facilitator', label: '진행자', type: 'text' },
            { key: 'materials', label: '준비물/자료', type: 'textarea' },
        ],
        mentoring: [
            { key: 'mentor_pool', label: '멘토 풀(쉼표 구분)', type: 'text' },
            { key: 'session_minutes', label: '세션 시간(분)', type: 'number' },
            { key: 'total_sessions', label: '총 세션 수', type: 'number' },
            { key: 'match_method', label: '매칭 방식', type: 'select', options: ['지정', '신청', '추천'] },
            { key: 'topics', label: '주요 주제', type: 'textarea' },
        ],
        networking: [
            { key: 'invitee_target', label: '대상', type: 'text' },
            { key: 'expected_count', label: '예상 참석자 수', type: 'number' },
        ],
        site_visit: [
            { key: 'destination', label: '방문지', type: 'text' },
            { key: 'transport', label: '교통편', type: 'text' },
            { key: 'agenda', label: '방문 일정', type: 'textarea' },
        ],
        ir_pitching: [
            { key: 'audience', label: '대상 투자자', type: 'text' },
            { key: 'pitch_minutes', label: '발표 시간(분)', type: 'number' },
            { key: 'qna_minutes', label: 'Q&A 시간(분)', type: 'number' },
        ],
        demoday: [
            { key: 'venue', label: '장소', type: 'text' },
            { key: 'audience', label: '청중', type: 'text' },
            { key: 'pitch_minutes', label: '팀당 발표 시간(분)', type: 'number' },
            { key: 'awards', label: '시상 내역', type: 'textarea' },
        ],
        funding_match: [
            { key: 'target_amount', label: '목표 매칭 금액(억)', type: 'number' },
            { key: 'investor_pool', label: '투자자 풀', type: 'textarea' },
        ],
        expense_mgmt: [
            { key: 'budget_total', label: '총 예산(만원)', type: 'number' },
            { key: 'categories', label: '집행 항목(쉼표 구분)', type: 'text' },
            { key: 'approval_required', label: '결재 필요', type: 'checkbox' },
        ],
        survey: [
            { key: 'cycle', label: '조사 시점', type: 'select', options: ['중간', '종료', '중간+종료', '회차별'] },
            { key: 'anonymous', label: '익명 여부', type: 'checkbox' },
        ],
        company_mgmt: [
            { key: 'pm', label: '담당 PM', type: 'text' },
            { key: 'meeting_cycle', label: '미팅 주기', type: 'select', options: ['주간', '격주', '월간', '분기'] },
        ],
        follow_up: [
            { key: 'duration_months', label: '관리 기간(월)', type: 'number' },
            { key: 'metrics', label: '추적 지표', type: 'textarea' },
        ],
        reporting: [
            { key: 'cycle', label: '보고 주기', type: 'select', options: ['주간', '월간', '분기', '연간'] },
            { key: 'report_to', label: '제출처', type: 'text' },
        ],
    };

    public mentorModuleTypes: string[] = [
        'selection', 'diagnosis', 'education', 'workshop', 'mentoring',
        'networking', 'site_visit', 'ir_pitching', 'demoday', 'funding_match',
        'company_mgmt', 'follow_up', 'evaluation', 'ir', 'visit', 'etc'
    ];

    public sessionStatusMap: any = {
        planned: { label: '예정', cls: 'bg-blue-50 text-blue-700' },
        ongoing: { label: '진행중', cls: 'bg-emerald-50 text-emerald-700' },
        done: { label: '완료', cls: 'bg-zinc-100 text-zinc-700' },
        cancelled: { label: '취소', cls: 'bg-red-50 text-red-700' },
    };
    public attStatusMap: any = {
        registered: { label: '등록', cls: 'bg-zinc-100 text-zinc-700' },
        attended: { label: '참석', cls: 'bg-emerald-100 text-emerald-800' },
        absent: { label: '결석', cls: 'bg-red-100 text-red-800' },
        excused: { label: '공결', cls: 'bg-amber-100 text-amber-800' },
    };
    public submissionStatusMap: any = {
        draft: { label: '작성중', cls: 'bg-zinc-100 text-zinc-600' },
        submitted: { label: '제출완료', cls: 'bg-blue-50 text-blue-700' },
        reviewed: { label: '검토완료', cls: 'bg-emerald-50 text-emerald-700' },
        returned: { label: '반려', cls: 'bg-red-50 text-red-700' },
    };

    public meta(): any {
        return this.typeMeta[this.module_type] || this.typeMeta.etc;
    }

    public schemaFor(t: string = this.module_type): any[] {
        return this.fieldSchemas[t] || [];
    }

    public usesMentorSelection(): boolean {
        return this.mentorModuleTypes.indexOf(this.module_type) !== -1;
    }

    private _clone(v: any): any {
        if (typeof v === 'string') {
            try { v = JSON.parse(v || '{}'); }
            catch { v = {}; }
        }
        if (!v || typeof v !== 'object' || Array.isArray(v)) v = {};
        try { return JSON.parse(JSON.stringify(v || {})); }
        catch { return {}; }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }

    public async ngOnChanges() {
        if (this.module_id) await this.reload();
    }

    private _emptySession() {
        return {
            module_id: this.module_id, program_id: this.program_id,
            round_no: (this.sessions.length || 0) + 1,
            title: `${this.meta().label} ${(this.sessions.length || 0) + 1}회차`,
            start_at: '', end_at: '', location: '', online_url: '',
            instructor: '', materials: '', status: 'planned'
        };
    }

    private async reload() {
        if (!this.module_id) return;
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get_module', { module_id: this.module_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '모듈 로딩 실패', action: '확인' });
            return;
        }
        this.module = r.data.data;
        if (this.module?.module_type) this.module_type = this.module.module_type;
        this.configForm = this._clone(this.module?.config || {});
        await this.loadSessions();
        if (this.meta().useSubmission) await this.loadSubmissions();
        if (this.meta().useFeedback) await this.loadFeedbacks();
        await this.loadApplications();
        if (this.usesMentorSelection()) {
            await this.loadMentorUsers();
            await this.loadAssignments();
        } else {
            this.mentorUsers = [];
            this.assignments = [];
            this.selectedAssignmentIds = {};
        }
        this.loaded = true;
        await this.service.render();
    }

    public async loadSessions() {
        const r = await wiz.call('list_sessions', { module_id: this.module_id });
        if (r.code == 200) this.sessions = r.data.rows || [];
        await this.service.render();
    }
    public async loadSubmissions() {
        const r = await wiz.call('list_submissions', { module_id: this.module_id });
        if (r.code == 200) this.submissions = r.data.rows || [];
        await this.service.render();
    }
    public async loadFeedbacks() {
        const r = await wiz.call('list_feedbacks', { module_id: this.module_id });
        if (r.code == 200) this.feedbacks = r.data.rows || [];
        await this.service.render();
    }
    public async loadApplications() {
        // 선발 모듈은 전체 신청기업 노출, 그 외 모듈은 선정 기업만 노출
        const status = this.meta().useApplicants ? this.applicantStatusFilter : 'selected';
        const r = await wiz.call('list_applications', { program_id: this.program_id, module_id: this.module_id, status });
        if (r.code == 200) {
            this.applications = r.data.rows || [];
            this.syncApplicationAssignments();
        }
        await this.service.render();
    }

    public appStatusInfo(s: string) {
        return this.appStatusMap[s] || { label: s || '-', cls: 'bg-zinc-100 text-zinc-600' };
    }

    public toggleApplicant(appId: string) {
        this.expandedAppId = (this.expandedAppId === appId) ? '' : appId;
        this.service.render();
    }

    public attachmentDownloadUrl(appId: string, att: any): string {
        if (!appId || !att || !att.stored_name) return '#';
        const params = new URLSearchParams({
            application_id: appId,
            stored_name: att.stored_name,
            original_name: att.original_name || att.stored_name,
        });
        return `/wiz/api/portal.lpsysadmin.support.program.item/download_application_file?${params.toString()}`;
    }

    public formatBytes(n: any): string {
        const v = Number(n) || 0;
        if (v < 1024) return v + ' B';
        if (v < 1024 * 1024) return (v / 1024).toFixed(1) + ' KB';
        return (v / 1024 / 1024).toFixed(2) + ' MB';
    }

    public formatMoney(n: any): string {
        return (Number(n) || 0).toLocaleString();
    }

    public async setApplicantStatusFilter(s: string) {
        this.applicantStatusFilter = s;
        await this.loadApplications();
    }

    public async setApplicantStatus(app: any, newStatus: string) {
        if (!app || !app.id) return;
        if (!confirm(`'${app.company_name}' 의 상태를 '${this.appStatusInfo(newStatus).label}'으로 변경하시겠습니까?`)) return;
        const r = await wiz.call('update_application_status',
            { id: app.id, status: newStatus });
        if (r.code != 200) {
            this.service.alert.show({ title: '상태 변경 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.loadApplications();
    }

    public async setTab(t: string) {
        this.tab = t;
        // 선발 탭으로 이동 시 전체 신청기업 재조회
        if (t === 'applicants') await this.loadApplications();
        if (t === 'mentors' && this.usesMentorSelection()) {
            await this.loadMentorUsers();
            await this.loadAssignments();
        }
        await this.service.render();
    }

    // ===== Settings =====
    public async saveConfig() {
        const normalized = this._clone(this.configForm || {});
        for (const f of this.schemaFor()) {
            if (f.type === 'number' && normalized[f.key] !== '' && normalized[f.key] != null) {
                normalized[f.key] = Number(normalized[f.key]) || 0;
            }
            if (f.type === 'checkbox') {
                normalized[f.key] = !!normalized[f.key];
            }
        }
        this.configSaving = true;
        await this.service.render();
        const r = await wiz.call('update_config', {
            module_id: this.module_id,
            config: JSON.stringify(normalized),
        });
        this.configSaving = false;
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '운영 설정 저장에 실패했습니다.', action: '확인' });
            return;
        }
        this.configForm = normalized;
        if (this.module) this.module.config = this._clone(normalized);
        this.service.alert.show({ title: '저장 완료', message: '운영 설정을 저장했습니다.', action: '확인' });
        await this.service.render();
    }

    // ===== Mentor / expert assignment =====
    public async loadMentorUsers() {
        const r = await wiz.call('list_mentors', {});
        if (r.code == 200) this.mentorUsers = r.data.rows || [];
        await this.service.render();
    }

    public async loadAssignments() {
        const r = await wiz.call('list_assignments', { program_id: this.program_id, module_id: this.module_id });
        if (r.code == 200) {
            this.assignments = r.data.rows || [];
            const validIds: any = {};
            for (const a of this.assignments) validIds[a.id] = true;
            for (const id of Object.keys(this.selectedAssignmentIds || {})) {
                if (!validIds[id]) delete this.selectedAssignmentIds[id];
            }
            this.syncApplicationAssignments();
        }
        await this.service.render();
    }

    public async refreshMentorAssignments() {
        await this.loadApplications();
        await this.loadMentorUsers();
        await this.loadAssignments();
    }

    public syncApplicationAssignments() {
        for (const app of (this.applications || [])) {
            const a = this.assignmentForApplication(app.id);
            app._mentor_user_id = a?.mentor_user_id || '';
        }
    }

    public assignmentForApplication(appId: string): any {
        const roles = ['mentor', 'primary', 'secondary'];
        return (this.assignments || []).find((a: any) =>
            a.application_id === appId && a.status !== 'cancelled' && roles.indexOf(a.role || 'mentor') !== -1
        ) || null;
    }

    public assignmentIdForApplication(appId: string): string {
        const a = this.assignmentForApplication(appId);
        return a?.id || '';
    }

    public isAssignmentSelectedForApp(appId: string): boolean {
        const id = this.assignmentIdForApplication(appId);
        return !!(id && this.selectedAssignmentIds[id]);
    }

    public isInviteLoadingForApp(appId: string): boolean {
        const id = this.assignmentIdForApplication(appId);
        return !!(id && this.inviteLoading[id]);
    }

    public isMentorInviteLoadingForApp(appId: string): boolean {
        const id = this.assignmentIdForApplication(appId);
        return !!(id && this.mentorInviteLoading[id]);
    }

    public mentorUserId(m: any): string {
        return m?.user_id || m?.id || '';
    }

    public mentorDisplayName(m: any): string {
        return m?.name || m?.email || this.mentorUserId(m);
    }

    public mentorDisplayMeta(m: any): string {
        return [m?.email, m?.affiliation || m?.org, m?.position, m?.expertise].filter((v: any) => !!v).join(' · ');
    }

    public assignmentMentorName(a: any): string {
        if (!a) return '-';
        return a.mentor_name || a.mentor?.name || a.mentor_email || a.mentor_user_id || '-';
    }

    public async saveMentorForApp(app: any) {
        if (!app?.id) return;
        this.assignmentSaving[app.id] = true;
        await this.service.render();
        const r = await wiz.call('set_module_assignee', {
            program_id: this.program_id,
            module_id: this.module_id,
            application_id: app.id,
            mentor_user_id: app._mentor_user_id || '',
            role: 'mentor',
        });
        this.assignmentSaving[app.id] = false;
        if (r.code != 200) {
            this.service.alert.show({ title: '배정 실패', message: r.data?.message || '멘토 배정 저장에 실패했습니다.', action: '확인' });
            return;
        }
        await this.loadAssignments();
    }

    public async clearMentorForApp(app: any) {
        if (!app) return;
        app._mentor_user_id = '';
        await this.saveMentorForApp(app);
    }

    public toggleAssignmentSelection(a: any, checked: boolean) {
        if (!a?.id) return;
        this.selectedAssignmentIds[a.id] = !!checked;
        this.service.render();
    }

    public selectedAssignmentCount(): number {
        return Object.keys(this.selectedAssignmentIds || {}).filter((id: string) => !!this.selectedAssignmentIds[id]).length;
    }

    public selectedAssignments(): any[] {
        return (this.assignments || []).filter((a: any) => !!this.selectedAssignmentIds[a.id]);
    }

    public async sendMenteeInvite(a: any) {
        if (!a?.id) return;
        const ok = await this.service.alert.show({
            title: '초대 메일 발송',
            message: `${a.application_company || this.companyName(a.application_id)} 기업에 멘토링 일정 조율 링크를 발송하시겠습니까?`,
            action: '발송',
            cancel: '취소',
        });
        if (!ok) return;
        await this._sendInvite(a, true);
    }

    private async _sendInvite(a: any, showAlert: boolean = false): Promise<boolean> {
        this.inviteLoading[a.id] = true;
        await this.service.render();
        const r = await wiz.call('create_mentee_invite', { assignment_id: a.id });
        this.inviteLoading[a.id] = false;
        if (r.code != 200) {
            if (showAlert) this.service.alert.show({ title: '발송 실패', message: r.data?.message || '메일 발송에 실패했습니다.', action: '확인' });
            return false;
        }
        if (showAlert) this.service.alert.show({ title: '발송 완료', message: '초대 메일을 발송했습니다.', action: '확인' });
        return true;
    }

    public async sendMentorInvite(a: any) {
        if (!a?.id) return;
        const ok = await this.service.alert.show({
            title: '멘토 배정 메일 발송',
            message: `${this.assignmentMentorName(a)}에게 ${a.application_company || this.companyName(a.application_id)} 배정 안내 메일을 발송하시겠습니까?`,
            action: '발송',
            cancel: '취소',
        });
        if (!ok) return;
        await this._sendMentorInvite(a, true);
    }

    private async _sendMentorInvite(a: any, showAlert: boolean = false): Promise<boolean> {
        this.mentorInviteLoading[a.id] = true;
        await this.service.render();
        const r = await wiz.call('send_mentor_assignment_invite', { assignment_id: a.id });
        this.mentorInviteLoading[a.id] = false;
        if (r.code != 200) {
            if (showAlert) this.service.alert.show({ title: '발송 실패', message: r.data?.message || '멘토 메일 발송에 실패했습니다.', action: '확인' });
            return false;
        }
        if (showAlert) this.service.alert.show({ title: '발송 완료', message: '멘토 배정 안내 메일을 발송했습니다.', action: '확인' });
        return true;
    }

    public async sendSelectedMenteeInvites() {
        const targets = this.selectedAssignments();
        if (targets.length === 0) return;
        const ok = await this.service.alert.show({
            title: '기업 메일 발송',
            message: `선택한 ${targets.length}건의 대상 기업에게 일정 조율 초대 메일을 발송하시겠습니까?`,
            action: '발송',
            cancel: '취소',
        });
        if (!ok) return;
        this.bulkInviteLoading = true;
        await this.service.render();
        let sent = 0;
        let failed = 0;
        for (const a of targets) {
            const okSend = await this._sendInvite(a, false);
            if (okSend) sent += 1;
            else failed += 1;
        }
        this.bulkInviteLoading = false;
        this.service.alert.show({
            title: '발송 완료',
            message: `발송 ${sent}건 / 실패 ${failed}건`,
            action: '확인',
        });
        await this.service.render();
    }

    public async sendSelectedMentorInvites() {
        const targets = this.selectedAssignments();
        if (targets.length === 0) return;
        const ok = await this.service.alert.show({
            title: '멘토 메일 발송',
            message: `선택한 ${targets.length}건의 멘토에게 배정 안내 메일을 발송하시겠습니까?`,
            action: '발송',
            cancel: '취소',
        });
        if (!ok) return;
        this.bulkInviteLoading = true;
        await this.service.render();
        let sent = 0;
        let failed = 0;
        for (const a of targets) {
            const okSend = await this._sendMentorInvite(a, false);
            if (okSend) sent += 1;
            else failed += 1;
        }
        this.bulkInviteLoading = false;
        this.service.alert.show({
            title: '발송 완료',
            message: `발송 ${sent}건 / 실패 ${failed}건`,
            action: '확인',
        });
        await this.service.render();
    }

    // ===== Sessions =====
    public openSessionCreate() {
        this.editingSession = this._emptySession();
        this.showSessionEditor = true;
        this.service.render();
    }
    public openSessionEdit(s: any) {
        this.editingSession = JSON.parse(JSON.stringify(s));
        this.showSessionEditor = true;
        this.service.render();
    }
    public closeSessionEditor() {
        this.showSessionEditor = false;
        this.editingSession = null;
        this.service.render();
    }
    public async saveSession() {
        if (!this.editingSession) return;
        this.editingSession.round_no = Number(this.editingSession.round_no) || 1;
        const isNew = !this.editingSession.id;
        const r = isNew
            ? await wiz.call('create_session', { data: JSON.stringify(this.editingSession) })
            : await wiz.call('update_session', { id: this.editingSession.id, data: JSON.stringify(this.editingSession) });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.showSessionEditor = false;
        await this.loadSessions();
    }
    public async deleteSession(s: any) {
        if (!confirm(`${s.title}을(를) 삭제하시겠습니까?`)) return;
        const r = await wiz.call('delete_session', { id: s.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        if (this.selectedSession && this.selectedSession.id === s.id) {
            this.selectedSession = null;
            this.attendance = [];
        }
        await this.loadSessions();
    }

    public async selectSession(s: any) {
        this.selectedSession = s;
        if (this.meta().useAttendance) {
            const r = await wiz.call('list_attendance', { session_id: s.id });
            if (r.code == 200) this.attendance = r.data.rows || [];
        }
        await this.loadAttendanceRequests();
        await this.service.render();
    }

    public async loadAttendanceRequests() {
        if (!this.selectedSession) { this.attendanceRequests = []; return; }
        const r = await wiz.call('list_attendance_requests', { session_id: this.selectedSession.id });
        if (r.code == 200) this.attendanceRequests = r.data.rows || [];
        await this.service.render();
    }

    public async sendAttendanceRequests() {
        if (!this.selectedSession) return;
        if (!confirm('등록된 모든 참여기업에게 참석확인 메일을 발송하시겠습니까?\n(이미 발송된 기업은 자동 스킵됩니다.)')) return;
        this.attReqLoading = true;
        await this.service.render();
        const r = await wiz.call('send_attendance_requests', { session_id: this.selectedSession.id });
        this.attReqLoading = false;
        if (r.code != 200) {
            this.service.alert.show({ title: '발송 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        const d = r.data.data || {};
        this.service.alert.show({
            title: '발송 완료',
            message: `발송: ${d.sent || 0}건 / 스킵: ${d.skipped || 0}건 / 실패: ${d.failed || 0}건`,
            action: '확인'
        });
        await this.loadAttendanceRequests();
    }

    public async resendAttendanceRequest(req: any) {
        if (!confirm(`${req.recipient_email || req.recipient_name}에게 다시 발송하시겠습니까?`)) return;
        const r = await wiz.call('resend_attendance_request', { request_id: req.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '재발송 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '재발송 완료', message: '메일을 다시 발송했습니다.', action: '확인' });
        await this.loadAttendanceRequests();
    }

    public attReqStatusInfo(s: string) {
        return this.attReqStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public async bulkRegister() {
        if (!this.selectedSession) return;
        if (!confirm('선정된 모든 기업을 등록하시겠습니까?')) return;
        const r = await wiz.call('bulk_register', { session_id: this.selectedSession.id });
        if (r.code != 200) {
            this.service.alert.show({ title: '등록 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.selectSession(this.selectedSession);
    }

    public async setAttendance(att: any, status: string) {
        const r = await wiz.call('mark_attendance', {
            session_id: att.session_id, application_id: att.application_id, status
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        att.status = status;
        await this.service.render();
    }

    // ===== Submissions =====
    public openReview(s: any) {
        this.reviewing = s;
        this.reviewForm = {
            comment: s.reviewer_comment || '',
            status: s.status === 'submitted' ? 'reviewed' : (s.status || 'reviewed'),
            score: s.review_score != null ? String(s.review_score) : ''
        };
        this.service.render();
    }
    public closeReview() {
        this.reviewing = null;
        this.service.render();
    }
    public async saveReview() {
        if (!this.reviewing) return;
        const r = await wiz.call('review_submission', {
            id: this.reviewing.id,
            comment: this.reviewForm.comment,
            status: this.reviewForm.status,
            score: this.reviewForm.score,
        });
        if (r.code != 200) {
            this.service.alert.show({ title: '저장 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.reviewing = null;
        await this.loadSubmissions();
    }

    // ===== Feedback =====
    public openFeedback() {
        this.newFeedback = {
            content: '', score: 0, feedback_type: 'general',
            application_id: '', is_visible_to_company: true,
            program_id: this.program_id, module_id: this.module_id
        };
        this.showFeedback = true;
        this.service.render();
    }
    public closeFeedback() {
        this.showFeedback = false;
        this.service.render();
    }
    public async submitFeedback() {
        if (!this.newFeedback.content) {
            this.service.alert.show({ title: '입력 오류', message: '내용을 입력하세요.', action: '확인' });
            return;
        }
        this.newFeedback.score = Number(this.newFeedback.score) || 0;
        const r = await wiz.call('create_feedback', { data: JSON.stringify(this.newFeedback) });
        if (r.code != 200) {
            this.service.alert.show({ title: '등록 실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        this.showFeedback = false;
        await this.loadFeedbacks();
    }
    public async removeFeedback(f: any) {
        if (!confirm('피드백을 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_feedback', { id: f.id });
        if (r.code != 200) return;
        await this.loadFeedbacks();
    }

    public sessionStatusInfo(s: string) {
        return this.sessionStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }
    public attStatusInfo(s: string) {
        return this.attStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }
    public subStatusInfo(s: string) {
        return this.submissionStatusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' };
    }

    public companyName(appId: string): string {
        const a = this.applications.find(x => x.id === appId);
        return a ? a.company_name : appId;
    }
}

export default PortalLpsysadminSupportModuleGenericComponent;